import { useEffect } from "react";

export const GOOGLE_PREFERRED_SOURCE_SCRIPT_ID =
  "google-preferred-source-script";
export const GOOGLE_PREFERRED_SOURCE_SCRIPT_SRC =
  "https://news.google.com/swg/js/v1/publisher.js";

export default function GooglePreferredSourceScript() {
  useEffect(() => {
    const existingScript = document.querySelector(
      `script[src="${GOOGLE_PREFERRED_SOURCE_SCRIPT_SRC}"]`,
    );

    if (existingScript) return;

    const script = document.createElement("script");
    script.id = GOOGLE_PREFERRED_SOURCE_SCRIPT_ID;
    script.setAttribute("preferred-sources-control", "manual");
    script.async = true;
    script.src = GOOGLE_PREFERRED_SOURCE_SCRIPT_SRC;
    document.head.appendChild(script);
  }, []);

  return null;
}
